import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Lock } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminChangePassword = () => {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getToken = () => localStorage.getItem('admin_token');

  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(`${API}/api/auth/me`, { headers: { 'Authorization': `Bearer ${getToken()}` } });
      if (!res.ok) throw new Error();
    } catch { navigate('/admin'); }
  }, [navigate]);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setMsg(''); setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/change-password`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${getToken()}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ current_password: currentPw, new_password: newPw })
      });
      if (!res.ok) { const d = await res.json(); throw new Error(d.detail || 'Napaka'); }
      setMsg('Geslo uspešno spremenjeno!');
      setCurrentPw(''); setNewPw('');
    } catch (err) { setError(err.message); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-cream">
      <div className="max-w-md mx-auto px-4 py-6">
        <Link to="/admin/dashboard" className="flex items-center gap-1 text-stone-600 hover:text-violet-700 text-sm mb-6"><ArrowLeft size={16} />Nazaj</Link>
        <h1 className="font-serif text-3xl text-stone-800 font-bold mb-6">Spremeni geslo</h1>
        <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-stone-200 p-6">
          {msg && <div className="bg-green-50 text-green-600 text-sm px-3 py-2 rounded-lg mb-4">{msg}</div>}
          {error && <div className="bg-red-50 text-red-600 text-sm px-3 py-2 rounded-lg mb-4">{error}</div>}
          <div className="mb-4">
            <label className="block text-stone-700 text-sm font-medium mb-1">Trenutno geslo</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <input type="password" value={currentPw} onChange={e => setCurrentPw(e.target.value)} className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-stone-200 text-sm" required data-testid="current-pw" />
            </div>
          </div>
          <div className="mb-6">
            <label className="block text-stone-700 text-sm font-medium mb-1">Novo geslo</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-stone-200 text-sm" required data-testid="new-pw" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-violet-500 hover:bg-violet-600 text-white rounded-lg" data-testid="change-pw-btn">
            {loading ? 'Shranjujem...' : 'Spremeni geslo'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminChangePassword;
